import Component from "./ButtonComponent";
export default Component;
